import { useState, useEffect } from 'react';
import { getAllCustomers } from '../services/api/customerApi';

/**
 * Hook to fetch and manage customers list
 */
export const useCustomer = (params = {}) => {
    const [customers, setCustomers] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchCustomers = async () => {
            try {
                setLoading(true);
                const response = await getAllCustomers({ page: 0, size: 1000, ...params }); // Fetch all for lookup
                setCustomers(response.content || []);
                setError(null);
            } catch (err) {
                console.error('Error fetching customers:', err);
                setError(err);
            } finally {
                setLoading(false);
            }
        };

        fetchCustomers();
    }, [JSON.stringify(params)]);

    return { customers, loading, error };
};
